import { Component, Input } from '@angular/core';
import { AppContextService } from '@caslink/common-client/ng-app/appContext/AppContextService';

@Component({
    template: ''
})
export abstract class DeviceStatusLoadedLocationBaseComponent {
    public abstract appContextService: AppContextService;
    // for this controller you can be viewing a location that isn't loaded,
    // but we still need to know the one that is for signalR updates -- TODO
    private _loadedLocationId: number;

    @Input() set loadedLocationId(val: number) {
        this._loadedLocationId = val;
    }
    get loadedLocationId(): number {
        if (this._loadedLocationId) {
            return this._loadedLocationId;
        }

        return this.appContextService.loadedLocationId;
    }
}
